import React, {useEffect, useState} from 'react';
import { Container, Dialog, DialogTitle, 
  DialogContent, DialogActions, DialogContentText,
  Button, 
  Typography} from '@mui/material';
import { Box } from '@mui/system';
import { NewUserForm } from '../components/NewUserForm';
import { UserList } from '../components/UserList';
import { useUserInfoContext } from '../contexts/UserInfoContext';
import { UnauthorizedPage } from "../components/auth/Unauthorized";
import Api from '../services/Api';
import { ActiveDeploymentControlStandalone } from '../components/ActiveDeploymentControl';
import UserUtils from '../utils/userUtils';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { FailSnack, SuccessSnack } from '../components/Snackbars';
import UserRoleUpdater from '../components/UserRoleUpdater';




export const UserManagementView = () => {
  const {checkIfUserHasRole, userInfo} = useUserInfoContext();
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [reloadData, setReload] = useState(true);
  const [successOpen, setSuccessOpen] = useState(false);
  const [failOpen, setfailOpen] = useState(false);

  useDocumentTitle("Organization Management");
  const handleClose = () => { 
    setOpen(false);
    setToDelete(null);
  }

  useEffect(() => {
    if (reloadData && checkIfUserHasRole(UserUtils.RoleObjects['orgAdmin'].name)){
      getUsers();
      setReload(false);
    }
  }, [reloadData, setReload, setUsers, checkIfUserHasRole]);

  const getUsers = async () => {
    let userData = await Api.getAllUsersForOrg();
    if (userData !== null){
      setUsers(userData);
    }
  }

  const OnUserDelete = (user) => {
    setToDelete(user);
    setOpen(true);
  }

  const CommitDelete = async () => {
    setOpen(false);
    if (toDelete){
      let success = await Api.deleteUser(toDelete.id);
      if (success){
        setReload(true);
      }
    }
    setToDelete(null);
  }
  
  const HandleCancel = () => {
    setToDelete(null);
    setOpen(false);
  }

  const submitNewUser = async (email, username, role, sendEmailCheck=false) => {
    if (email === "" || username === "" || role < 0){
      return false;
    }
    let newUser = await Api.postNewUser(email, username, role);
    let success = Boolean(newUser); //true if an obj, false if null/false/undefined/0
    if (success){
      if (sendEmailCheck){
        await sendWelcomeEmail(newUser, true);
      }
      setReload(true);
    }
    return success;
    // let success = await submitAsync(email, username, role);
  }

  const sendWelcomeEmail = async (newUser, triggerSnackbars=false) => {
    if (newUser?.id === undefined) {return false;}
    let emailSuccess = await Api.postSendWelcomeEmail(newUser.id);
    if (emailSuccess && triggerSnackbars){
      setSuccessOpen(true);
    }else if (!emailSuccess && triggerSnackbars){
      setfailOpen(true);
    }
    return emailSuccess;
  }

  const onSendEmailClick = async (user) => {
    let emailSuccess = await sendWelcomeEmail(user, true);
    if (emailSuccess){
      setReload(true);
    }
  }

  const onRoleSubmit = async (user, newRole) => {
    let userId = user.id;
    let newRoleValue = newRole.value;
    let succ = await Api.postUserRoleUpdate(userId, newRoleValue);
    if (succ) {
      await getUsers();
    }
  }

  const getUsersForRole = () => {
    let toUseForRole = [];
    users.forEach(x => {
      if (x.id !== userInfo.id) {toUseForRole.push(x)}
    });
    return toUseForRole;
  }

  const getRoles = () => {
    let roleArr = [];
    let roleObjects = UserUtils.RoleObjects;
    Object.keys(roleObjects).forEach(k => {
      // if (roleObjects[k].value !== roleObjects['admin'].value) 
      roleArr.push(roleObjects[k]);
    });
    return roleArr;
  }

  return (
    <>
    {checkIfUserHasRole('orgAdmin') ? 
      <Container>
        <Typography variant="h4" sx={{marginBottom: '1em'}}>
          Organization Management
        </Typography>

        {/* <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "1em", textAlign: 'center'}}>
          <Typography variant="h5" sx={{marginBottom: "1em"}}>
            Manage Current Deployment
          </Typography>
        </Box>

        <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "2em"}}>

          <ActiveDeploymentControlStandalone viewButton={true}/>
        </Box> */}

        <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "2em"}}>
          <NewUserForm submitAsync={submitNewUser} assignRoles={true} sendEmail={true}/>
        </Box>

        <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "1em", textAlign: 'center'}}>
          <Typography variant="h5" sx={{marginBottom: "1em"}}>
            Current Users
          </Typography>
        </Box>

        <Box>
          <UserList users={users} onDelete={OnUserDelete} onMailSend={onSendEmailClick}/>
        </Box>

        <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "1em", textAlign: 'center'}}>
          <Typography variant="h5" sx={{marginBottom: "1em"}}>
            Update Roles
          </Typography>
        </Box>

        <Box sx={{maxWidth: "66%", margin: 'auto', marginBottom: "1em", textAlign: 'center'}}>
          <UserRoleUpdater users={getUsersForRole()} roleObjs={getRoles()} onSubmit={onRoleSubmit}/>
        </Box>

        <Dialog
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            Are you sure you'd like to delete this user?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you'd like to delete user: {toDelete ? toDelete.userName : ""} ? <br/>
              You cannot undo this action once completed.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={HandleCancel} autoFocus>Cancel</Button>
            <Button onClick={CommitDelete} color="warning">Delete</Button>
          </DialogActions>


        </Dialog>
        <SuccessSnack message={"Email Succesfully Sent"} open={successOpen} onClose={() => setSuccessOpen(false)}/>
        <FailSnack message={"Email Failed To Send"} open={failOpen} onClose={() => setfailOpen(false)}/>

      </Container> 
    :
    <UnauthorizedPage home={true}/>
    }
    </>
  )
}